import React, { Component } from "react";
import { Row, Col, Button, Modal } from "react-bootstrap";

class ChemistOperation extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  Submit = () => {
    let value = {
      ...this.props.ChemistOperationDtls,
      refreshParams: this.props.refreshParams,
    };
    this.props.ChemistOprMode(value);
    this.props.handleClose();
    this.props.resetPage();
  };

  render() {
    const data =
      this.props.ChemistOperationDtls && this.props.ChemistOperationDtls.item
        ? this.props.ChemistOperationDtls &&
          this.props.ChemistOperationDtls.item
        : null;
    // console.log(data);
    return (
      <div>
        <div className="userModalDiv">
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="md"
            backdrop="static"
            centered={true}
            // className="modal-backdrop fade show"
          >
            {data !== null && data.oprMode === "closed" ? (
              <Modal.Body>
                <div>
                  <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                    <b>Change the chemist's mode of operation to "Open" ?</b>
                  </h6>
                </div>
                <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="danger"
                      className="cmnDelCnclBtn"
                      onClick={() => this.props.handleClose()}
                    >
                      CANCEL
                    </Button>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="success"
                      className="cmnDelOkBtn"
                      onClick={this.Submit}
                    >
                      OK
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
            ) : (
              <Modal.Body>
                <div>
                  <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                    <b>Change the chemist's mode of operation to "Closed" ?</b>
                  </h6>
                </div>
                <Row style={{ marginTop: "30px", marginBottom: "30px" }}>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="danger"
                      className="cmnDelCnclBtn"
                      onClick={() => this.props.handleClose()}
                    >
                      CANCEL
                    </Button>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="success"
                      className="cmnDelOkBtn"
                      onClick={this.Submit}
                    >
                      OK
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
            )}
          </Modal>
        </div>
      </div>
    );
  }
}

export default ChemistOperation;
